import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import multicreationFiltersFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_filters_form_submit';

import urlParser from 'bloko/common/urlParser';

import {
    AuctionCampaignCreationStatus,
    FilterOption,
    setMultiCreationVacancies,
    setMultiCreationVacanciesIsLoading,
    setNotAvailableForCreationVacancies,
    Vacancy,
    VacancyFilterKeys,
} from 'store/models/multiCreation';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type FetchVacancySearch = (options: {
    abortSignal?: AbortSignal;
    nameFilter?: string;
    [VacancyFilterKeys.Areas]?: FilterOption[];
    [VacancyFilterKeys.Users]?: FilterOption[];
}) => AppThunkAction<Promise<void> | null>;

export const fetchVacancySearch: FetchVacancySearch = ({ abortSignal, nameFilter, areas, users }) => {
    return (dispatch, getState) => {
        const selectedFilters = getState().multiCreation.selectedFilters;
        const vacancySearchValue = getState().multiCreation.vacancySearchValue;

        dispatch(setMultiCreationVacanciesIsLoading(true));

        const areaIds = (areas ?? selectedFilters.areas).map((filter) => filter.value);
        const usersIds = (users ?? selectedFilters.users).map((filter) => filter.value);

        const queryStr = urlParser.stringify({
            nameFilter: nameFilter === undefined ? vacancySearchValue : nameFilter,
            areaId: areaIds,
            usersId: usersIds,
        });

        return fetcher
            .get<unknown, Vacancy[]>(`/api/v1/vacancy/active_vacancies/?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((vacancies) => {
                dispatch([
                    setMultiCreationVacancies(
                        vacancies.filter(
                            ({ auctionCampaignCreationStatus }) =>
                                auctionCampaignCreationStatus === AuctionCampaignCreationStatus.NotCreated
                        )
                    ),
                    setNotAvailableForCreationVacancies(
                        vacancies.filter(
                            ({ auctionCampaignCreationStatus }) =>
                                auctionCampaignCreationStatus !== AuctionCampaignCreationStatus.NotCreated
                        )
                    ),
                ]);
                multicreationFiltersFormSubmit({
                    searchValue: vacancySearchValue,
                    areaIds: areaIds.toString(),
                    managerIds: usersIds.toString(),
                });
            })
            .catch((error) => {
                dispatch(addNotification(NotificationName.SomethingWentWrong));
                multicreationFiltersFormSubmit({
                    searchValue: vacancySearchValue,
                    areaIds: areaIds.toString(),
                    managerIds: usersIds.toString(),
                    errors: JSON.stringify(error),
                });
            })
            .finally(() => {
                dispatch(setMultiCreationVacanciesIsLoading(false));
            });
    };
};
